var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconScaleInfrastructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 35V16.0177C36.6667 13.8128 36.6667 12.7104 36.0935 11.8566C35.5205 11.0028 34.5057 10.5933 32.476 9.77447L22.476 5.73993C21.2533 5.24665 20.642 5 20 5C19.358 5 18.7467 5.24665 17.524 5.73993L7.52407 9.77447C5.49438 10.5933 4.47955 11.0028 3.90645 11.8566C3.33333 12.7104 3.33333 13.8128 3.33333 16.0177V35M26.6667 31.6667V35M13.3333 31.6667V35M12.5 23.3333L12.9042 21.7165C13.5105 19.2912 13.8137 18.0787 14.7179 17.3727C15.6221 16.6667 16.872 16.6667 19.3718 16.6667H20.6282C23.128 16.6667 24.3778 16.6667 25.2822 17.3727C26.1863 18.0787 26.4895 19.2912 27.0958 21.7165L27.5 23.3333M14.1667 27.4833V27.5M25.8333 27.4833V27.5M28.3333 23.3333H11.6667C10.7462 23.3333 10 24.0795 10 25V30C10 30.9205 10.7462 31.6667 11.6667 31.6667H28.3333C29.2538 31.6667 30 30.9205 30 30V25C30 24.0795 29.2538 23.3333 28.3333 23.3333Z",
    stroke: "#0A66C2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScaleInfrastructure);
export default __webpack_public_path__ + "static/media/icon_scale_infrastructure.596151ed1ec536a3fac56a8b0842db6a.svg";
export { ForwardRef as ReactComponent };